<template>
  <div
    class="game-body"
    v-if="loadedPage"
    :style="cssProps">
    <div class="game-desktop-background"></div>
    <div v-if="step != 'finished'" class="game-content-background"></div>
    <span
      v-if="isDevelopment"
      class="dev-navigation">
      DEV
      <router-link class="btn" :to="{ name: 'WebShopOnboarding' }">onboarding</router-link>
    </span>

    <div
      v-if="step == 'finished'"
      class="game-page-absolute">
      <div v-html="game.winner_text"></div>
      <div class="btn btn-activate"
        @click="ctaDoneRedirect()">
        {{ game.cta_done_button || transl.Games.back }}
      </div>
    </div>

    <div v-else class="game-page">
      <div
        v-if="step == 'web-shop'"
        class="shop-container">
        <div
          v-if="game.terms_text || game.hunt_image"
          class="image-container">
          <div
            v-if="game.terms_text"
            class="info-icon-bottom-right"
            @click="tocModal = true"
            style="cursor: pointer;" >
            <iconComponent
              class="game-info-icon"
              symbol="info"
              width="18px"/>
          </div>
          <img class="tiebreaker-image" v-if="game.hunt_image" :src="game.hunt_image.url" alt="">
        </div>

        <div class="shop-header">
          <div class="points-grid">
            <img
              class="shop-header-icon-11"
              v-if="localCompany.icon_1x1?.url"
              :src="localCompany.icon_1x1.url"
              alt="">
            <img
              class="shop-header-icon-original"
              v-else-if="localCompany.icon?.url"
              :src="localCompany.icon.url"
              alt="">
            <div v-else></div>
            <div
              class="shop-header-search"
              :class="{ 'active-search': activeSearch }">
              <iconComponent
                class="clickable"
                symbol="magnifyingGlass"
                width="30px"
                @click="searchModal = true"/>
            </div>
            <div class="shop-header-cart-container">
              <iconComponent
                class="shop-header-cart clickable"
                symbol="shop"
                width="30px"
                @click="cartModal = true"/>
              <span v-if="cart.length > 0" class="cart-badge">{{ cart.length }}</span>
            </div>
            <!--<div class="shop-header-points">
              <div class="shop-header-points-header">{{ game.hunt_header }}</div>
              <div class="shop-header-points-text" :style="`color: ${game.accent_color};`"> {{ participation.points_balance }}</div>

              <div
                v-if="participation?.claims?.length"
                class="shop-header-claims clickable"
                @click="claimsModal = true">
                <iconComponent symbol="gift" :width="25" :fill="game.accent_color"/>
              </div>
            </div>-->
          </div>
        </div>
        <!--
          <div class="countdown">{{ countdown }}</div>
        -->

        <div v-if="expiredShop">The shop is now closed!</div>
        <div
          v-else
          class="shop-content">
          <div v-if="game.hunt_body" class="game-hunt-body" v-html="game.hunt_body.interpolate({ username: user.name })"></div>
          <h3>{{ transl.Goodiebag.products }}</h3>
          <div
            v-for="prize in filteredPrizes"
            :key="prize.prize_type"
            class="prize">
            <div
              class="prize--image"
              :style="`background-image: url(${prize.media?.url})`"></div>
            <div class="prize--name">
              {{ prize.name }}
            </div>
            <div class="prize--description">
              <div class="prize--cost">
                {{ prize.cost }}
              </div>
              <div
                class="prize--description-estimate"
                :style="`color: ${prize.color || 'black'}`">
                {{ prize.estimate }}
              </div>
              <div
                class="prize--description-button btn btn-activate"
                :class="{ 'btn-disabled': prize.outofstock }"
                @click="claimPrize(prize.prize_type)">{{ game.claim_button_text || 'Claim' }}</div>
            </div>
          </div>
          <div
            v-if="!filteredPrizes.length"
            class="prize">No found products</div>
        </div>
        <!--<div
          class="bottom-content text-align-center"
          style="margin: 0 16px;">
          <h3>{{ game.hunt_funfacts_header }}</h3>
          <div v-html="game.hunt_funfacts[randomIndex]"></div>
        </div>-->
      </div>

      <div
        v-else-if="step == 'address'"
        class="survey-wrapper">
        <Form
          class="game-form"
          :questions="addressForm"
          :answers="addressData"
          :accentColor="game.accent_color"
          :textColor="game.text_color"
          :submitButton="transl.UserPV.submit"
          @answeredAll="addressData = $event"
          @missingRequired="addressData = {}"
          @submit="setAddress({ setAddress: true })"/>
      </div>

      <div
        v-else-if="step == 'survey'"
        class="survey-wrapper">

        <!-- Trigger snackbar when finished ? and send email to participation -->
        <div class="survey-container">
          <div class="points-grid" v-if="participation && participation.points">
            <span class="scan-text">{{ game.hunt_header }}</span>
            <span class="points-text" :style="`color: ${game.accent_color};`"> {{ participation.points.length }}</span>
          </div>

          <div class="survey-header">{{ game.survey_header }}</div>
          <Form
            class="survey-all-questions"
            :questions="game.survey"
            :accentColor="game.accent_color"
            :textColor="game.text_color"
            :submitButton="transl.Games.submit"
            @answeredAll="surveyAnswers = $event"
            @missingRequired="surveyAnswers = {}"
            @submit="setSurvey()"/>
        </div>
      </div>
    </div>

    <!--
      In the case of desktop, the scrollbar will affect the poistion of the game-page
      style="padding: 5px 10px 10px 15px"
    -->

    <modal v-if="tocModal" @close="tocModal = false" size="medium" padding="0" :terms="true">
      <slot>
        <div class="terms-wrapper">
          <div v-html="game.terms_text" class="html-text"></div>
        </div>
        <div class="terms-buttons">
          <div
            v-if="authenticated && game.terms_merchandise && !participation.accepted_merchandise && !hasAcceptedGame"
            class="terms-merchandise-grid">
            <inputField
              v-model="acceptMerchandise"
              inputType="checkbox"/>
            <span
              class="terms-merchandise-text"
              v-html="game.terms_merchandise"></span>
          </div>

          <div v-if="authenticated && !hasAcceptedGame" class="btn btn-activate" @click="acceptGameTerms()">
            {{ transl.UserPV.accept }}
          </div>

          <div class="btn btn-secondary" @click="tocModal = false">
            {{ transl.UserPV.close }}
          </div>
        </div>
      </slot>
    </modal>

    <modal
      v-if="cartModal"
      @close="cartModal = false" size="large">
      <slot>
        <div class="claims-wrapper">
          <div class="claims-header" v-html="game.claims_description"></div>
          <div class="claims">
            <div
              v-for="claim in cart"
              :key="claim._id"
              class="claim">
              <div
                v-if="claim.media?.url"
                class="claim--image"
                :style="`background-image: url(${claim.media?.url})`" alt=""></div>
              <div class="claim--name"><b>{{ claim.name }}</b></div>
              <div class="claim--tracking">{{ cartTimers[claim._id] }}</div>
            </div>
          </div>
        </div>

        <div class="btn btn-secondary" @click="cartModal = false">
          {{ transl.UserPV.gotopayment }}
        </div>
        <div class="btn btn-secondary" @click="cartModal = false">
          {{ transl.UserPV.close }}
        </div>
      </slot>
    </modal>

    <modal
      v-if="searchModal"
      @close="searchModal = false" size="medium">
      <slot>
        <div class="shop-search-modal">
          <InputField
            v-model="query"
            class="search-input"
            placeholder="Find product"
            trailingIcon="magnifyingGlass"/>
          <VueSlider
            v-model="costRange"
            class="search-filter"
            label="Cost"
            :min="costStart"
            :max="costEnd"
            :interval="100"
            tooltip="hover"
            :dotSize="16"
            :height="6"
            :use-range="true"/>

          Found: {{ filteredPrizes.length }} products
        </div>
      </slot>
    </modal>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { cloneDeep as _cloneDeep } from 'lodash-es';
import VueSlider from 'vue-slider-component';
import BeforeEnterMixin from '../../mixins/BeforeEnterMixin';
import EntityMixin from '../../mixins/EntityMixin';
import InputField from '../../stories/components/InputField/InputField';
import Form from '../../stories/components/Form/Form';

export default {
  name: 'WebShopHome',
  components: {
    // Logo,
    VueSlider,
    InputField,
    Form
  },
  props: ['gameId'],
  mixins: [BeforeEnterMixin, EntityMixin],
  data() {
    return {
      loadedPage: false,
      isDevelopment: process.env.NODE_ENV !== 'production',
      gameType: 'WebShop',
      step: 'web-shop',
      countdown: 0,
      expiredShop: false,
      acceptMerchandise: true,
      acceptTerms: false,
      tocModal: false,
      surveyAnswers: [],
      firstTime: true,
      disableTryAgain: false,
      activateErrorMsg: null,
      currentUnix: (new moment).unix(),
      timeInterval: null,
      randomIndex: 0,
      enlargedMap: false,
      addressForm: [],
      addressData: {
        nameAtAddress: '',
        address: '',
        postalCode: '',
        city: '',
        state: '',
        country: '',
      },
      claimedPrize: null,
      claimsModal: false,
      filteredPrizes: [],
      query: '',
      searchModal: false,
      activeSearch: false,
      costRange: [0, 0],
      costStart: 0,
      costEnd: 0,
      cartModal: false,
      cartTimers: {},
      cartIntervals: {},
      paymentToken: '',
    };
  },
  mounted() {
    this.getGame();
  },
  destroyed() {
    Object.keys(this.cartIntervals).forEach((id) => {
      clearInterval(this.cartIntervals[id]);
    });
    clearTimeout(this.timeInterval);
  },
  watch: {
    authenticated(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getGame();
      }
    },
    query() {
      this.searchPrizes();
    },
    costRange: {
      handler() {
        this.searchPrizes();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters([
      'authenticated',
      'user',
      'participation',
      'canAddParticipation',
      'reason',
      'prizes',
      'cart',
    ]),
    cssProps() {
      return {
        '--game-desktop-bg-color': this.game.desktop_bg_color,
        '--game-bg-color': this.game.bg_color,
        '--game-bg-text-color': this.game.bg_text_color,
        '--game-accent-color': this.game.accent_color,
        '--game-accent-color-rgb': this.convertToRGB(this.game.accent_color),
        '--game-text-color': this.game.text_color,
      }
    },
    hasCurrentParticipation() {
      return this.participation && this.participation._id;
    },
    hasAcceptedGame() {
      if (!this.user || !this.user._id) {
        return false;
      }
      return this.game.accepted_terms;
    },
  },
  methods: {
    getGame() {
      this.$store.dispatch('getGame', this.attach({ authenticated: this.authenticated }))
      .then((success) => {
        if (!success) {
          if (!this.game || !this.game._id) {
            this.setAlert(this.reason);
            this.$router.push({ name: 'UserStart' });
            return;
          }
          this.gotoError();
          return;
        }

        this.formatTime();
        this.calcCartTimers();

        this.setPageTitle(this.game.name, this.game.company.name);
        this.acceptMerchandise = this.game.terms_merchandise_default;
        // this.setRandomFact();
        this.pushDataLayer({
          parentCompany: this.game.company.parentCompany,
          company: this.game.company,
          game: this.game,
          action: 'Enter',
        });

        this.expiredShop = this.game.expires_at && this.game.expires_at < this.currentUnix;

        /*if (this.wsReady) {
          console.log('WebSocket connected for gameId:', `${this.user.phone_nr}_CART`);
          this.$socket.client.on(`${this.user.phone_nr}_CART`, (participation) => {
            console.log('IO_CART', participation);
            this.$store.commit('PARTICIPATION', participation);
            this.$store.commit('CART', participation.cart);
            this.setStep();
          });
        }*/

        this.setStep();
      });
    },
    setStep() {
      const game = this.game;
      const participation = this.participation;
      this.setCosts();
      this.searchPrizes();

      if ((!this.authenticated && game.must_login)
        || (!this.hasCurrentParticipation && !game.tiebreak)) {
        this.gotoOnboarding();
      } else if (!this.hasCurrentParticipation && !this.canAddParticipation) {
        this.gotoError();
      } else if (!this.hasCurrentParticipation && game.tiebreak) {
        this.step = 'tiebreaker';
        if (game.terms_must_accept && !this.hasAcceptedGame) {
          this.tocModal = true;
        }
      } else if (game.winner_address && participation.claims?.length && !participation.address) {
        this.addressForm = [
          {
            label: `${this.transl.Offer.firstname} ${this.transl.Offer.lastname}`,
            required: true,
            model: 'nameAtAddress',
            id: 'name',
          },
          {
            label: this.transl.Offer.street,
            required: true,
            model: 'address',
            id: 'address',
          },
          {
            label: this.transl.Offer.postalcode,
            required: true,
            model: 'postalCode',
            id: 'postal-code',
          },
          {
            label: this.transl.Offer.city,
            required: true,
            model: 'city',
            id: 'address-level2',
          },
        ];
        /*if (game.address_country) {
          this.addressForm.push({
            label: 'Ange ditt land',
            required: true,
            model: 'country',
            id: 'country',
            // options: [{ text: 'Sverige', _id: 'SE' }],
          });
        }
        if (game.address_state) {
          this.addressForm.push({
            label: 'Ange ditt landskap',
            required: true,
            model: 'state',
            id: 'state',
          });
        }*/

        let addressData = {
          nameAtAddress: `${this.user.name} ${this.user.last_name}`,
          address: this.user.adress,
          postalCode: this.user.postal_code,
          city: this.user.city,
          state: this.user.state,
          country: this.user.country,
        };

        this.addressData = addressData;
        this.step = 'address';
      } else if (participation.claims?.length && !participation.survey_answers?.length && this.game.survey?.length) {
        this.step = 'survey';
      } else {
        this.step = 'web-shop';
      }
      this.loadedPage = true;
    },
    searchPrizes() {
      const search = this.query.toLowerCase();
      if (search || this.costRange[0] != this.costStart || this.costRange[1] != this.costEnd) {
        this.activeSearch = true;
      } else {
        this.activeSearch = false;
      }
      this.filteredPrizes = this.prizes.filter((prize) => {
        return (
          (!search || (search && prize.name.toLowerCase().includes(search))) &&
          this.costRange[0] <= prize.cost &&
          prize.cost <= this.costRange[1]
        );
      });
    },
    setCosts() {
      this.costStart = 0;
      this.costEnd = 0;
      this.prizes.forEach((prize) => {
        if (this.costStart == 0 || this.costStart > prize.cost) {
          this.costStart = prize.cost;
          this.costRange[0] = prize.cost;
        }
        if (this.costEnd < prize.cost) {
          this.costEnd = prize.cost;
          this.costRange[1] = prize.cost;
        }
      });
    },
    claimPrize(name) {
      this.$store.dispatch("claimWebShopPrize", this.attach({
        offerType: name
      })).then(({ success, message, prize }) => {
        if (success) {
          this.claimedPrize = prize;
          this.setAlert(this.transl.Games.congratsclaim.interpolate({ prizename: prize.name }), 7);
          this.calcCartTimers();
          this.setStep();
        } else {
          this.setAlert(message, 5);
        }
      });
    },
    getPaymentToken() {
      this.$store.dispatch("getWebShopPaymentToken", this.attach({
        prizesLength: this.cart.length
      })).then(({ success, token, message }) => {
        if (success) {
          this.paymentToken = token;
        } else {
          this.setAlert(message, 5);
        }
      });
    },
    /*setRandomFact() {
      if (this.game.hunt_funfacts && this.game.hunt_funfacts.length) {
        this.randomIndex = this.getRandomInt(this.game.hunt_funfacts.length);
      }
    },*/
    acceptGameTerms() {
      this.tocModal = false;
      this.acceptTerms = true;
    },
    setAddress() {
      this.$store.dispatch('answerGameAddress', this.attach({ answers: this.addressData }))
      .then((success) => {
        if (!success) {
          this.setAlert(this.reason);
          return;
        }

        this.setStep();
      });
    },
    setSurvey() {
      this.$store.dispatch('answerGameSurvey', this.attach({ answers: this.surveyAnswers }))
      .then((success) => {
        if (!success) {
          this.setAlert(this.reason);
          return;
        }

        this.setStep();
      });
    },
    attach(obj) {
      obj.entityId = this.gameId;
      obj.entityType = this.gameType;
      return obj;
    },
    gotoError() {
      console.log('Home gotoError');
      this.$router.push({ name: 'WebShopError' });
    },
    gotoOnboarding() {
      console.log('Home gotoOnboarding');
      this.$router.push({ name: 'WebShopOnboarding' });
    },
    getRandomInt(max) {
      return Math.floor(Math.random() * max);
    },
    ctaDoneRedirect() {
      if (this.game.cta_done_url) {
        this.openUrl(this.game.cta_done_url, true);
      } else {
        this.$router.push({ name: 'HomeCompany', params: { companyId: this.getId(this.game.company) } });
      }
    },
    calcCartTimers() {
      const cartTimers = {};

      Object.keys(this.cartIntervals).forEach((id) => {
        clearInterval(this.cartIntervals[id]);
      });
      this.cartIntervals = {};

      this.cart.forEach((claim) => {
        const updateTimer = () => {
          const { ct } = this.formatT(claim.expires_at, this.getGame);
          cartTimers[claim._id] = ct;
        };

        updateTimer();
        this.cartIntervals[claim._id] = setInterval(updateTimer, 1000);
      });

      this.cartTimers = cartTimers;
    },
    formatTime() {
      const { ct, exp } = this.formatT(this.game.expires_at);
      this.countdown = ct;
      this.expiredShop = exp;
      this.timeInterval = setInterval(() => {
        const { ct, exp } = this.formatT(this.game.expires_at);
        this.countdown = ct;
        this.expiredShop = exp;
      }, 1000);
    },
    formatT(expiresAt, failFunc = () => {}) {
      let countdown = '';
      let expired = false;
      const unix = (new moment).unix();
      const duration = moment.duration(expiresAt - unix, 'seconds');
      const days = duration.days();
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();
      if (days < 0 || hours < 0 || minutes < 0 || seconds < 0) {
        expired = true;
        failFunc();
      } else {
        expired = false;
      }
      countdown = '';
      let largerExists = false;
      if (days > 0) {
        countdown += `${days}:`;
        largerExists = true;
      }
      if (hours > 0 || largerExists) {
        countdown += `${hours}:`;
        largerExists = true;
      }
      if (minutes > 0 || largerExists) {
        countdown += `${minutes}:`;
        largerExists = true;
      }
      if (seconds > 0 || largerExists) {
        countdown += `${seconds}`;
      }
      return { ct: countdown, exp: expired };
    },
    convertToRGB(color) {
      const tempElement = document.createElement('div');
      tempElement.style.color = color;
      document.body.appendChild(tempElement);
  
      const computedColor = getComputedStyle(tempElement).color;
      document.body.removeChild(tempElement);
  
      const rgbMatch = computedColor.match(/\d+, \d+, \d+/);
      return rgbMatch ? rgbMatch[0] : '0, 0, 0';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/games/WebShop/Base";
@import "../../assets/scss/games/WebShop/Home";
</style>
